<template>
  <main class="main-layout">
    <slot></slot>
  </main>
</template>

<script>
export default {
  name: 'MainLayout'
};
</script>

<style lang="scss" scoped>
.main-layout {
  display: grid;
  gap: 1rem;
  text-align: center;
  justify-content: center;
  margin: 2rem 0;
}

.chatbot {
  .main-layout {
    margin: 2rem .5rem;
    gap: .5rem;
  }
  .button {
    font-size: 1rem;
  }
}
</style>
